export const PATIENTS_TYPES = {
    INDIVIDUAL: {
        value: 'INDIVIDUAL',
        toDisplay: 'Particulier'
    },
    FIRM: {
        value: 'FIRM',
        toDisplay: 'Entreprise'
    }
};